import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../Componets/Header";
import Footer from "../../Componets/Footer";
import { Helmet } from "react-helmet-async";
import productsData from "../../Data/productsData";

function Reamer() {
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [secOpen, setSecOpen] = useState(false);
  const [ThirdOpen, setThirdOpen] = useState(false);
  const [fourOpen, setFourOpen] = useState(false);
  const [fiveOpen, setFiveOpen] = useState(false);
  const [sixOpen, setSixOpen] = useState(false);

  // Preloader timer
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const products = productsData.filter((item) => item.category === "Reamer");

  return (
    <>
      {loading && (
        <div id="pre-load">
          <div id="loader" className="loader">
            <div className="loader-container">
              <div className="loader-icon">
                <img src="/assets/images/favicon.png" alt="Loader" />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="rs-smoother-yes rtl">
        <div id="rs-mouse">
          <div id="cursor-ball"></div>
        </div>

        <Header />

        <Helmet>
          <title>
            {`Category | Reamer | ${process.env.REACT_APP_COMPANYNAME} | ${process.env.REACT_APP_PHONE1}`}
          </title>
          <meta
            name="description"
            content="Explore our complete range of high-precision cutting tools including drills, endmills, ballnose endmills, and reamers for CNC & VMC machining."
          />

          <link
            rel="canonical"
            href={`${process.env.REACT_APP_SITE_URL}/product/reamer`}
          />

          <meta
            property="og:url"
            content={`${process.env.REACT_APP_SITE_URL}/product/reamer`}
          />

          <meta
            property="og:title"
            content={`Cutting Tools Products | ${process.env.REACT_APP_COMPANYNAME}`}
          />

          <meta
            property="og:description"
            content="Discover precision cutting tools manufactured for high performance CNC & VMC machining applications."
          />

          <meta property="og:type" content="website" />
        </Helmet>
        {/* banner start */}
        <section className="inner-page-banner">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="/product">Our Product</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="#">Reamer</a>
                    </li>
                  </ol>
                </nav>
                <div className="title text-white text-center">
                  <h1 className="text-white product-heading">REAMER</h1>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* banner over */}

        <section className="rs-shop-area section-space">
          <div className="container">
            <div className="row g-5">
              <div className="col-xxl-8 col-xl-8 col-lg-8">
                <div className="row g-5">
                  {/* 🔥 DYNAMIC PRODUCT CARDS */}
                  {products.map((item) => (
                    <div
                      className="col-xl-4 col-lg-6 col-md-6 col-sm-6"
                      key={item.id}
                    >
                      <div className="rs-product-item">
                        <div className="rs-product-thumb products-category-card">
                          <Link to={`/product/${item.slug}`} key={item.id}>
                            <img src={item.images.main} alt={item.name} />
                            <h5>{item.name}</h5>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/*catrgories*/}
              <div className="col-xxl-4 col-xl-4 col-lg-4">
                <div className="rs-sidebar-wrapper rs-sidebar-sticky">
                  <div className="sidebar-widget widget-categories mb-30">
                    <h5 className="sidebar-widget-title">Product Categories</h5>
                    <div className="sidebar-widget-content">
                      <div className="list">
                        <ul>
                          {/* first Accordion */}
                          <div className="accordion  mt-4">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={`accordion-button accrodion-bg ${
                                    open ? "" : "collapsed"
                                  }`}
                                  onClick={() => setOpen(!open)}
                                >
                                  High-Performance-Drills
                                </button>
                              </h2>
                              <div
                                className={`accordion-collapse collapse show${
                                  open ? "show" : ""
                                }`}
                              >
                                <div className="accordion-body">
                                  <ul className="submenu">
                                    <li>
                                      <Link to="/product/micro-drills-non-through-coolant">
                                        Micro Drills Non Through Coolant
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to="/Product/standard-drills-non-through-coolant">
                                        Standard Drills Non Through Coolant
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to="/Product/standard-drills-through-coolant">
                                        Standard Drills Through Coolant
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to="/Product/center-drills">
                                        Central Drills
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* sec Accordion */}
                          <div className="accordion  mt-4">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={`accordion-button ${
                                    secOpen ? "" : "collapsed"
                                  }`}
                                  onClick={() => setSecOpen(!secOpen)}
                                  aria-expanded={secOpen}
                                  aria-controls="collapseOne"
                                >
                                  High-Performance-Endmills
                                </button>
                              </h2>
                              <div
                                className={`accordion-collapse collapse ${
                                  secOpen ? "show" : ""
                                }`}
                              >
                                <div className="accordion-body">
                                  <ul>
                                    <li>
                                      <Link to="/Product/regular-endmills">
                                        Regular Endmills
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to="/Product/long-endmills">
                                        Long Endmills
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to="/Product/extra-long-endmills">
                                        Extra Long Endmills
                                      </Link>
                                    </li>

                                    <li>
                                      <Link to="/Product/rougher-endmills">
                                        Rougher Endmills
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to="/Product/single-lip-endmills">
                                        Single Lip Endmills
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to="/Product/taper/stub-neck-endmill">
                                        Taper/Stub Neck Endmill
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to="/Product/3 fulte & 6 fulte-endmill">
                                        3 Fulte & 6 Fulte Endmill
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to="/product/corner-redius-endmills">
                                        Corner-Redius-Endmills
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Third Accordion */}
                          <div className="accordion  mt-4">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={`accordion-button ${
                                    ThirdOpen ? "" : "collapsed"
                                  }`}
                                  onClick={() => setThirdOpen(!ThirdOpen)}
                                >
                                  Chamfer-Tools
                                </button>
                              </h2>
                              <div
                                className={`accordion-collapse collapse ${
                                  ThirdOpen ? "show" : ""
                                }`}
                              >
                                <div className="accordion-body">
                                  <ul>
                                    <li>
                                      <Link to="/Product/chamfer">Chamfer</Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* four Accordion */}
                          <div className="accordion mt-4">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={`accordion-button ${
                                    fourOpen ? "" : "collapsed"
                                  }`}
                                  onClick={() => setFourOpen(!fourOpen)}
                                >
                                  Customized Tools
                                </button>
                              </h2>
                              <div
                                className={`accordion-collapse collapse ${
                                  fourOpen ? "show" : ""
                                }`}
                              >
                                <div className="accordion-body">
                                  <ul>
                                    <li>
                                      <Link to="/customized-tools">
                                        Customized tools
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* five Accordion */}
                          <div className="accordion mt-4">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={`accordion-button ${
                                    fiveOpen ? "" : "collapsed"
                                  }`}
                                  onClick={() => setFiveOpen(!fiveOpen)}
                                >
                                  Ballnose Endmills
                                </button>
                              </h2>
                              <div
                                className={`accordion-collapse collapse ${
                                  fiveOpen ? "show" : ""
                                }`}
                              >
                                <div className="accordion-body">
                                  <ul>
                                    <li>
                                      <Link to="/Product/regular-ballnose-endmills">
                                        Regular Ballnose Endmills
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to="/Product/long-ballnose-endmills">
                                        Long Ballnose Endmills
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to="/Product/extra-long-ballnose-endmills">
                                        Extra Long Ballnose Endmills
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* six Accordion */}
                          <div className="accordion mt-4">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className={`accordion-button ${
                                    sixOpen ? "" : "collapsed"
                                  }`}
                                  onClick={() => setSixOpen(!sixOpen)}
                                >
                                  Reamer
                                </button>
                              </h2>
                              <div
                                className={`accordion-collapse collapse ${
                                  sixOpen ? "show" : ""
                                }`}
                              >
                                <div className="accordion-body">
                                  <ul>
                                    <li>
                                      <Link to="/Product/reamer">Reamer</Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* download brochures start */}
              <div className="d-flex justify-content-end">
                <div class="sidebar-widget widget-download mb-30">
                  <h5 class="mb-25 sidebar-widget-title">Download Brochures</h5>
                  <ul>
                    <li>
                      <Link
                        className="categories-brochures"
                        to="/assets/PDF/BROCHURE.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div class="left">
                          <span>
                            <img src="assets/images/icon/pdf.svg" alt="#" />
                          </span>
                          <div>DOWNLOAD BROCHURE</div>
                        </div>
                        <span>
                          {/* <img
                                                     src="assets/images/icon/download-02.svg"
                                                     alt="#"
                                                   /> */}
                          <i className="fa-solid fa-download categories-download-icon"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              {/* download brochures end */}
            </div>
          </div>
        </section>

        <Footer />
        {/* Backtotop start  */}
        <div className="backtotop-wrap cursor-pointer has-theme-red">
          <svg
            className="backtotop-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
          </svg>
        </div>
        {/* <!-- Backtotop end --> */}
      </div>
    </>
  );
}

export default Reamer;
